// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#cancellation .single-section{background-color:var(--stepper-step-bg);border:1px solid var(--border-color);padding:30px 15px}#cancellation .section-header:not(:last-child){margin-bottom:1rem}#cancellation .section-header.title{font-size:17px;font-weight:700}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
